import React, { useState, useRef, useCallback, useEffect } from 'react';
import OutlinedClose from 'acud-icon/lib/icons/OutlinedClose';
import MultiToneClear from 'acud-icon/lib/icons/MultiToneClear';
import Input from './Input';
import Tooltip from '../tooltip';
import classNames from 'classnames';
import { ConfigContext } from '../config-provider';
const Label = ({ label, allowClear, onPressEnter, prefixCls: customizePrefixCls, placeholder = '', disabled, onLabelChange, }) => {
    const [labelList, setLabelList] = useState(label || []);
    const [inputValue, setInputValue] = useState('');
    const inputEl = useRef(null);
    const acudInputEl = useRef(null);
    const [clearIconColor, setClearIconColor] = useState('#D4D6D9');
    const [compositionStart, setCompositionStart] = useState(false);
    useEffect(() => {
        setLabelList(label || []);
    }, [label]);
    const handleClearLabel = (index) => {
        if (disabled) {
            return;
        }
        labelList.splice(index, 1);
        setLabelList([...labelList]);
        if (onLabelChange) {
            onLabelChange([...labelList]);
        }
    };
    const handleClearAll = () => {
        setLabelList([]);
        if (onLabelChange) {
            onLabelChange([]);
        }
        if (inputEl.current) {
            inputEl.current.focus();
        }
    };
    const handleOnchange = (e) => {
        if (disabled) {
            return;
        }
        setInputValue(e.target.value);
    };
    const handleOnKeyDown = (e) => {
        var _a;
        const value = (_a = inputEl.current) === null || _a === void 0 ? void 0 : _a.value;
        if (e.key === 'Enter' && inputValue) {
            if (!compositionStart) {
                if (onPressEnter) {
                    onPressEnter(e);
                }
                value && setLabelList([...labelList, value]);
                setInputValue('');
                if (onLabelChange) {
                    onLabelChange([...labelList, value]);
                }
            }
            else {
                if (onPressEnter) {
                    onPressEnter(e);
                }
            }
        }
        if (e.key === 'Backspace' && !value) {
            let labels = [...labelList];
            labels.pop();
            setLabelList(labels);
            if (onLabelChange) {
                onLabelChange([...labels]);
            }
        }
    };
    const handleClick = () => {
        if (disabled) {
            return;
        }
        if (inputEl.current) {
            inputEl.current.focus();
        }
    };
    const handleMouseDown = e => {
        e.preventDefault();
    };
    const handleInputBlur = () => {
        acudInputEl.current.blur();
        if (inputValue) {
            setLabelList([...labelList, inputValue]);
            setInputValue('');
            if (onLabelChange) {
                onLabelChange([...labelList, inputValue]);
            }
        }
    };
    const handleMouseUp = (e) => {
        e.preventDefault();
    };
    const clickClear = () => {
        handleClearAll();
    };
    const hoverClear = () => {
        setClearIconColor('#84868C');
    };
    const clearMouseLeave = () => {
        setClearIconColor('#D4D6D9');
    };
    const handleMouseDownClear = useCallback(e => {
        e.preventDefault();
    }, []);
    const { getPrefixCls } = React.useContext(ConfigContext);
    const prefixCls = getPrefixCls('input-label', customizePrefixCls);
    const inputBoxClassNames = classNames(`${prefixCls}-input-box`, {
        [`${prefixCls}-input-box-placeholder`]: !labelList.length && placeholder,
    });
    const renderLabel = () => {
        return (<ul className={`${prefixCls}-wrapper`} onClick={handleClick}>
                {labelList.map((item, index) => (<li key={index} className={`${prefixCls}-item`} aria-disabled={disabled}>
                        <Tooltip placement="top" title={item}>
                            <span className={`${prefixCls}-text`}>{item}</span>
                        </Tooltip>

                        <OutlinedClose className={`${prefixCls}-clear-icon`} disabled={disabled} onClick={() => handleClearLabel(index)} onMouseDown={handleMouseDown} onMouseUp={handleMouseUp}/>
                    </li>))}
                {<div className={inputBoxClassNames}>
                        <input className="label-input" ref={inputEl} disabled={disabled} value={inputValue} onChange={handleOnchange} onKeyDown={handleOnKeyDown} onBlur={handleInputBlur} onCompositionStart={() => setCompositionStart(true)} onCompositionEnd={() => setCompositionStart(false)} placeholder={labelList.length ? '' : placeholder}/>
                    </div>}
                {allowClear && !disabled && !!labelList.length && (<div className={`${prefixCls}-clear-wrapper`} onClick={clickClear} onMouseEnter={hoverClear} onMouseLeave={clearMouseLeave} onMouseDown={handleMouseDownClear}>
                        <MultiToneClear width={16} color={clearIconColor}/>
                    </div>)}
            </ul>);
    };
    return (<Input label={renderLabel()} disabled={disabled} ref={acudInputEl} handleClearAll={handleClearAll} allowClear={!!labelList.length}/>);
};
export default Label;
